import { useEffect, useState } from 'react';
import ownerSharingService, { ownerSharingEnabled } from '../services/ownerSharingService';
import { inSupportSession } from '../utils/supportSession';

const key = uid => `ownerSharingAccounts:${uid}`;

function cached(uid) {
  try { return uid ? sessionStorage.getItem(key(uid)) === '1' : false; } catch { return false; }
}

// True when the signed-in user is an admin of a company that owns locations or receives shares. Checked once per session.
// Platform staff are never company admins, and the API refuses their org-switch header, so they are not asked.
const STAFF_ROLES = ['developer', 'superuser', 'support'];

export default function useOwnerSharingAccounts(uid, role) {
  const [managesSharing, setManagesSharing] = useState(() => cached(uid));
  useEffect(() => {
    if (!ownerSharingEnabled() || !uid || STAFF_ROLES.includes(role) || inSupportSession()) { setManagesSharing(false); return undefined; }
    let known = null;
    try { known = sessionStorage.getItem(key(uid)); } catch { /* storage unavailable */ }
    if (known !== null) { setManagesSharing(known === '1'); return undefined; }
    let cancelled = false;
    ownerSharingService.accounts().then(result => {
      const value = result.accounts.length > 0 || (result.companies || []).length > 0;
      try { sessionStorage.setItem(key(uid), value ? '1' : '0'); } catch { /* storage unavailable */ }
      if (!cancelled) setManagesSharing(value);
    }).catch(() => { if (!cancelled) setManagesSharing(false); });
    return () => { cancelled = true; };
  }, [uid, role]);
  return managesSharing;
}
